import React from 'react';
import SelectInput, { IOption } from 'components/input/selectInput';

interface ContainerPanelProps {
  containers: IOption[];
  selectedPlateId: number;
  onPlateTypeSelect: (e: React.ChangeEvent<any>) => void;
  children: React.ReactNode;
}

export const ContainerPanel = ({
  containers,
  selectedPlateId,
  onPlateTypeSelect,
  children,
}: ContainerPanelProps) => {
  return (
    <div
      id="preferences-container-panel"
      className="flex m-2 PreferencesPanel PreferencesContainerPanel"
    >
      <div
        id="preferences-plate-selector"
        className="flex flex-row justify-between shrink-0"
      >
        <div id="preferences-plate-label" className="flex flex-grow-[1]">
          Plate Type Name
        </div>
        <div id="preferences-plate-dropdown" className="flex flex-grow-[2]">
          <SelectInput
            className="w-full"
            options={containers}
            value={selectedPlateId}
            onChange={onPlateTypeSelect}
          />
        </div>
      </div>
      <div
        id="preferences-propsview-panel"
        className="flex flex-1 min-h-0 m-2 PreferencesPanel PreferencesPropsViewPanel"
      >
        {children}
      </div>
    </div>
  );
};
